import { PRICE_USD, PRICE_UAH } from '@/config/pricing'
import * as api from '@/api'

const state = {
  priceUsd: PRICE_USD,
  priceUah: PRICE_UAH,
  isLoaded: false
}

const mutations = {
  SET_PRICE(state, { priceUsd, priceUah }) {
    if (priceUsd != null) state.priceUsd = priceUsd
    if (priceUah != null) state.priceUah = priceUah
    state.isLoaded = true
  }
}

const actions = {
  async FETCH_PRICE({ commit, state }) {
    try {
      const { data } = await api.price.getPrice()
      commit('SET_PRICE', {
        priceUsd: data.priceUsd ?? state.priceUsd,
        priceUah: data.priceUah ?? state.priceUah
      })
    } catch (err) {
      console.warn('FETCH_PRICE failed, keeping current/fallback price', err)
      if (!state.isLoaded) {
        commit('SET_PRICE', { priceUsd: PRICE_USD, priceUah: PRICE_UAH })
      }
    }
  }
}

const getters = {
  priceUsd: s => s.priceUsd,
  priceUah: s => s.priceUah,
  isPriceLoaded: s => s.isLoaded
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
